var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.833,26.5H25a3.476,3.476,0,0,0-6.673,0H2a1,1,0,0,0,0,2H18.33A3.476,3.476,0,0,0,25,28.5h3.83a1,1,0,0,0,0-2ZM21.667,29a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,21.667,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df2c30",
    d: "M27.86,1H4.14A3.143,3.143,0,0,0,1,4.14V19.86A3.143,3.143,0,0,0,4.14,23H27.86A3.143,3.143,0,0,0,31,19.86V4.14A3.143,3.143,0,0,0,27.86,1ZM29,19.86A1.141,1.141,0,0,1,27.86,21H4.14A1.141,1.141,0,0,1,3,19.86V4.14A1.141,1.141,0,0,1,4.14,3H27.86A1.141,1.141,0,0,1,29,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df2c30",
    d: "M21.53,11.152l-8-5A1,1,0,0,0,12,7V17a1,1,0,0,0,1.53.848l8-5a1,1,0,0,0,0-1.7ZM14,15.2V8.8L19.113,12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideos);
export default __webpack_public_path__ + "static/media/icon-videos.0d8e922bd4b0d1980bf91ae6a274532e.svg";
export { ForwardRef as ReactComponent };